<template>
  <td
    :class="[
      col.td.classes,
      {'is-fixed': col.isFixed},
      {'is-edit-available': isEditAvailable},
      {'is-edit': isEdit}
    ]"
    :style="[
      col.styles,
      col.td.styles,
      {transform: `${(col.isFixed) ? `translateX(${scroll.x}px)` : ''}`},
    ]">
    <div class="table-column-content__wrap">
      <!--TEMPLATE-->
      <div class="el-input__inner table-column-content">
        <component
          :is="columnTemplate"
          :row="row"
          :col="col"
          :template="template"
          @handle="(val) => $emit('handle', val)"/>
      </div>
      <!--EDITOR-->
      <grid-editor
        v-if="isEditAvailable"
        :row="row"
        :col="col"
        @isEdit="(val) => this.isEdit = val"
        @change="(editor, data, callback) => $emit('change', row, editor, data, callback)"
        ref="GridEditor"/>
    </div>
  </td>
</template>

<script>
export default {
  name: 'GridColumn',
  components: {
    'grid-editor': () => import(/* webpackChunkName: 'Grid' */ '../Editors/GridEditor')
  },
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    scroll: { type: Object, required: true },
    isPreviewMode: { type: Boolean, default: false }
  },
  data () {
    return {
      isEdit: false,
      columnTemplate: null,
      template: {}
    }
  },
  created () {
    // TODO: validate filter type
    let type = 'string'
    if (this.col.template) {
      if (typeof this.col.template === 'string') {
        type = this.col.template
      } else if (typeof this.col.template === 'function') {
        type = 'function'
        this.template.function = this.col.template
      } else if (typeof this.col.template === 'object') {
        type = this.col.template.type
        this.template = this.col.template
      }
    }
    if (type) {
      this.columnTemplate = () => import(/* webpackChunkName: 'Grid' */ `@/components/Grid/Columns/${type}/index.vue`)
    } else {
      throw Error('Error parse column template')
    }
  },
  computed: {
    isEditAvailable () {
      return this.col.editor && !this.isPreviewMode
    }
  }
}
</script>
<style lang="stylus">
  .table-column-content__wrap{
    position relative
  }
</style>
